module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/axios/index.js
// module id = 277
// module chunks = 2